import React, { useState, useEffect } from 'react';
import { getFCMToken } from '../notification/firebase';

const NotificationSoftAsk = () => {
  const [showPrompt, setShowPrompt] = useState(false);

  // useEffect(() => {
  //   if (Notification.permission === 'default') {
  //     const timer = setTimeout(() => {
  //       setShowPrompt(true);
  //     }, 0);

  //     return () => clearTimeout(timer);
  //   }
  // }, []);

  const handleAllowNotifications = async () => {
    setShowPrompt(false);
    await getFCMToken();
  };

  const handleNoThanks = () => {
    setShowPrompt(false);
  };

  if (!showPrompt) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      zIndex: 1000,
      backgroundColor: '#000',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
      textAlign: 'center',
      maxWidth: '320px',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h3 style={{ margin: '0 0 10px 0', color: '#fff' }}>🔔 Stay Updated!</h3>
      <p style={{ fontSize: '14px', lineHeight: '1.5', color: '#fff' }}>
        Enable push notifications to receive important alerts, updates, and exclusive offers.
      </p>
      <div style={{ marginTop: '15px' }}>
        <button
          onClick={handleAllowNotifications}
          style={{
            backgroundColor: '#007bff',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '15px',
            marginRight: '10px',
            boxShadow: '0 2px 4px rgba(0,123,255,0.2)'
          }}
        >
          Yes, Enable
        </button>
        <button
          onClick={handleNoThanks}
          style={{
            backgroundColor: '#e9e9e9',
            color: '#555',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '15px'
          }}
        >
          No Thanks
        </button>
      </div>
    </div>
  );
};

export default NotificationSoftAsk;
